import React, { useState } from 'react';
import { UserStatus, User, RoleName } from '@marageti/z4-sdk/lib/auth';
import { useContextMenu, useApiClient, useFetch } from '@marageti/z4-lib';
import { TeamMember } from '@marageti/z4-sdk/lib/people';
import { enqueueSnackbar } from 'notistack';
import { useParams } from 'react-router-dom';
import UserProfileView from './user-profile-view';
import { useAuthStore } from '../../../../store';

const UserProfileContainer = () => {
  const { userId } = useParams(); // This is actually the teamMemberId
  const apiClient = useApiClient();
  const { loggedInTeamMember } = useAuthStore();

  const { data: teamMember, error: TMError, mutate: mutateTM } = useFetch<TeamMember>(apiClient.peopleClient.getTeamMember, [userId], true);
  const { data: user, mutate: mutateUser } = useFetch<User>(apiClient.authClient.getUser, [teamMember?.userInfo[0].id], true);

  const [contextMenuAnchor, setContextMenuAnchor, contextMenuOpen] = useContextMenu();
  const [editorOpen, setEditorOpen] = useState(false);
  const buttonId = `${teamMember?.id}-context-button`;
  const menuId = `${teamMember?.id}-context-menu`;

  const isAdmin = loggedInTeamMember?.userInfo?.some((info) => info.roles?.includes(RoleName.ADMIN)) || false;

  const onClickNewStatus = async (status: UserStatus) => {
    if (user && teamMember) {
      const updatedUser = {
        ...user,
        status,
      };

      try {
        await apiClient.authClient.putUser(user.id, updatedUser);
        mutateUser();
        setContextMenuAnchor(null);
        enqueueSnackbar('User status updated.', { variant: 'success' });
      } catch (error) {
        enqueueSnackbar('An error occurred while updating user status.', { variant: 'default' });
        // eslint-disable-next-line no-console
        console.error('Error updating user status:', error);
      }
    }
  };

  const handleCloseEditor = () => {
    mutateTM();
    mutateUser();
    setEditorOpen(false);
  };
  const handleOpenEditor = () => setEditorOpen(true);

  const handleEditAvatar = async (avatar: string) => {
    if (teamMember) {
      try {
        const { avatar: updatedAvatar } = await apiClient.peopleClient.putTeamMemberAvatar(teamMember.id, {
          id: teamMember.id,
          avatar,
        });
        mutateTM({ ...teamMember, avatar: updatedAvatar }, { revalidate: false });
      } catch (error) {
        enqueueSnackbar('The image could not be uploaded', { variant: 'default' });
      }
    }
  };

  const editContextMenu = {
    id: 'user-profile-context-menu',
    items: [{
      label: 'Edit',
      action: handleOpenEditor,
    }],
  };

  return (
    <UserProfileView
      buttonId={buttonId}
      contextMenuAnchor={contextMenuAnchor}
      contextMenuOpen={contextMenuOpen}
      error={TMError}
      menuId={menuId}
      onClickNewStatus={onClickNewStatus}
      onEditAvatar={handleEditAvatar}
      teamMember={teamMember}
      user={user}
      setContextMenuAnchor={setContextMenuAnchor}
      status={user?.status}
      contextMenuProps={editContextMenu}
      editorOpen={editorOpen}
      onCloseEditor={handleCloseEditor}
      isAdmin={isAdmin}
    />
  );
};
export default UserProfileContainer;
